/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  ISignUpUserMethods,
  SignUpUserService,
  URLService,
  IURLMethods,
  IVerifyUserMethods,
  VerifyUserService,
} from './plugins';

export type TAgent = IStaticPageContentMethods &
  ISignUpUserMethods &
  IURLMethods &
  IVerifyUserMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new SignUpUserService(),
    new URLService(),
    new VerifyUserService(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
